"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ECategorieSocialProfessionnel_1 = require("../../enums/ClientSheet/ECategorieSocialProfessionnel");
const ECivility_1 = require("../../enums/ClientSheet/ECivility");
const EFiscalRegime_1 = require("../../enums/ClientSheet/EFiscalRegime");
const ELegalCapacity_1 = require("../../enums/ClientSheet/ELegalCapacity");
const EMaritalStatus_1 = require("../../enums/ClientSheet/EMaritalStatus");
const EMatrimonialRegime_1 = require("../../enums/ClientSheet/EMatrimonialRegime");
const ECountry_1 = require("../../enums/Country/ECountry");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const AddressCreateRequestResource_1 = __importDefault(require("../Address/AddressCreateRequestResource"));
const Custom_1 = __importDefault(require("../decorators/Custom"));
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../injectables/Di"));
const Resource_1 = __importDefault(require("../Resource"));
class ClientSheetUpdateRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.civility = ECivility_1.ECivility.non_communique;
        this.politicallyExposed = false;
        this.personUS = false;
    }
}
exports.default = ClientSheetUpdateRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, CustomAsync_1.default)((id) => Di_1.default.getClientService().clientSheetExists(id), {
        message: ValidationErrors_1.EValidationError.clientNotExists,
    }),
    (0, class_validator_1.IsUUID)("all"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECivility_1.ECivility),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "civility", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.civility === ECivility_1.ECivility.madame)
            return true;
        obj.maidenName = null;
        return false;
    }),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetUpdateRequestResource.prototype, "maidenName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, Custom_1.default)((value) => new Date(value) < new Date(), { message: ValidationErrors_1.EValidationError.mustBeInThePast }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ClientSheetUpdateRequestResource.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "birthPlace", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "birthDepartment", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "birthCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "nationality", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetUpdateRequestResource.prototype, "profession", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "nif", void 0);
__decorate([
    (0, CustomAsync_1.default)((email, args) => Di_1.default.getClientService().hasDifferentEmailThanSpouse(args.object.id, email), {
        message: ValidationErrors_1.EValidationError.isSameEmailThanSpouse,
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetUpdateRequestResource.prototype, "email", void 0);
__decorate([
    (0, CustomAsync_1.default)((phone, args) => Di_1.default.getClientService().hasDifferentPhoneThanSpouse(args.object.id, phone), {
        message: ValidationErrors_1.EValidationError.isSamePhoneThanSpouse,
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsPhoneNumber)("FR"),
    (0, class_validator_1.IsNumberString)({ no_symbols: false }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetUpdateRequestResource.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "taxResidenceCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ELegalCapacity_1.ELegalCapacity),
    (0, class_validator_1.Equals)(ELegalCapacity_1.ELegalCapacity.majeur_capable, { message: ValidationErrors_1.EValidationError.blockOperation }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "legalCapacity", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetUpdateRequestResource.prototype, "politicallyExposed", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, Custom_1.default)((value) => value === false, { message: ValidationErrors_1.EValidationError.personUSmustBeFalse }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetUpdateRequestResource.prototype, "personUS", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(EMaritalStatus_1.EMaritalStatus),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetUpdateRequestResource.prototype, "maritalStatus", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.maritalStatus === EMaritalStatus_1.EMaritalStatus.marie || obj.maritalStatus === EMaritalStatus_1.EMaritalStatus.pacse)
            return true;
        obj.matrimonialRegime = null;
        return false;
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(EMatrimonialRegime_1.EMatrimonialRegime),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetUpdateRequestResource.prototype, "matrimonialRegime", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsEnum)(EFiscalRegime_1.EFiscalRegime, { each: true }),
    (0, Custom_1.default)((value) => value.includes(EFiscalRegime_1.EFiscalRegime.BIC) || value.includes(EFiscalRegime_1.EFiscalRegime.IRPP) || value.includes(EFiscalRegime_1.EFiscalRegime.BNC) || value.includes(EFiscalRegime_1.EFiscalRegime.AUTRE_NON_RESIDENT), {
        message: ValidationErrors_1.EValidationError.mustIncludeBicOrIrppOrBnc,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ClientSheetUpdateRequestResource.prototype, "fiscalRegimes", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetUpdateRequestResource.prototype, "agreementElectronicDocument", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AddressCreateRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", AddressCreateRequestResource_1.default)
], ClientSheetUpdateRequestResource.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetUpdateRequestResource.prototype, "nonProfessionalClassificationAcknowledgment", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(60),
    (0, class_validator_1.MinLength)(1),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetUpdateRequestResource.prototype, "lineOfBusiness", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ECategorieSocialProfessionnel_1.ECategorieSocialProfessionnel),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetUpdateRequestResource.prototype, "categorieSocialProfessionnel", void 0);
